import clsx from 'clsx';
import { PropsWithChildren } from 'react';

interface StyledFormHeaderProps {
  title: string;
  subTitle?: string;
  sticky?: boolean;
}

const StyledFormHeader = ({
  title,
  subTitle,
  sticky = false,
  children,
}: PropsWithChildren<StyledFormHeaderProps>) => {
  return (
    <div
      className={clsx(
        'flex flex-col md:flex-row w-full justify-between h-auto p-6 gap-6',
        {
          'sticky top-0 md:top-18 bg-brand-25 z-10': sticky,
        },
      )}
    >
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-semibold text-gray-950">{title}</h1>
        {subTitle && (
          <p className="text-sm leading-4 text-gray-600">{subTitle}</p>
        )}
      </div>
      <div className="flex flex-col md:flex-row gap-4">{children}</div>
    </div>
  );
};

export default StyledFormHeader;
